var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body-2 notice"},[(_vm.userCupNotice)?_c('span',[_vm._v(_vm._s(_vm.$t('gameLegal.usercup'))+" "),_c('br')]):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('gameLegal.default'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }